/**
 * @file science Hooks
 * @author v_duzhengqiang
 */

import { useState } from 'react';
import { useMount } from 'react-use';
import { getCmsDataInfo } from '../../api/pages/paddleCmsGetDataApi';
import {
  RootObject
} from './type';


const useScienceHooks = () => {
    // // 数据
    const [data, setData] = useState<RootObject>({
        scienceBanner:{
            scienceBannerTitle:"",
            scienceBannerContent:"",
            backImg:"",
            scienceBannerJumpContent: [],
            bannerImg:"",
            description: ""
        },
        coreStrengths: {
            coreStrengthsTitle: "",
            description: "",
            coreStrengthsModule: []
        },
        fluidMechanics:{
            CooperationCaseTitle:"",
            CooperationCaseContent:"",
            backImg:"",
            CooperationCaseTabsList: [],
            description: ""
        },
        molecularDynamics:{
            CooperationCaseTitle:"",
            CooperationCaseContent:"",
            backImg:"",
            CooperationCaseTabsList: [],
            description: ""
        },
        partners:{
            partnersTitle: "",
    partnersContent: [],
    description: ""
        },
        needToContact:{
            NeedToContactTitle: "",
            NeedToContactContent: "",
            NeedToContactJumpContent: {
                title:"",
                detailLink:""
            },
            backImg: "",
            description: ""
        }
    });
  
    useMount(() => {
        (async () => {
            const res = await getCmsDataInfo({ requestUrl: '/science' })
                .catch((err) => {
                    // ignore
                });
            if (res) {
                const data = res.body.result?.pageData || {};
                // console.log(data);
                
                data && setData(data);
               
            }
        })();
    });
    return {
       data
      
    }
}

export default useScienceHooks;